<div class="local-import-table">
  <div class="local-import-table-header">
    <div class="local-import-table-header-filename">{{ 'localImport.labels.fileName' | translate }}</div>
    <div class="local-import-table-header-contains">{{ 'common.labels.contains' | translate }}</div>
    <div class="local-import-table-header-size">{{ 'common.labels.size' | translate }}</div>
    <div class="local-import-table-header-status">{{ 'common.labels.status' | translate }}</div>
    <div class="local-import-table-header-action"></div>
  </div>
  <div class="local-import-table-body">
    <local-import-table-folder-row
      *ngFor="let folder of (folderData.dirList | alphaNumericSort: 'name'); trackBy: trackByForFolderFn"
      [folder]="folder" (cancelFile)="onCancelFiles([$event])" [status]="folder.status"
      (retryFile)="onRetryFiles([$event])" (retryFolder)="onRetryFolder($event)"
      (cancelFolder)="onCancelFolder($event)"></local-import-table-folder-row>
    <local-import-table-file-row
      *ngFor="let file of (folderData.files | alphaNumericSort: 'fileName'); trackBy: trackByForFileFn" [file]="file"
      [status]="file.status" [completedPartsSize]="file.completedPartsSize" (cancel)="onCancelFiles([$event])"
      (retry)="onRetryFiles([$event])"></local-import-table-file-row>
  </div>
</div>
